import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import api from "@/lib/axios"
import SkeletonTable from "@/components/SkeletonTable"

const getListUnitkerjaGroup = async () => {
  const response = await api.get("/master/unit-kerja-group/index", {
    withCredentials: true,
  })
  return response.data?.data
}

export default function MasterUnitkerjaGroupPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listUnitkerjaGroup"],
    queryFn: getListUnitkerjaGroup,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
